// Packages
import React from "react";
import { IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

import useComponents from "../../components";
import useLayouts from "../../layouts";

// Controllers
import useControllers from "../../../controllers";

const Login = () => {
  const { Wrapper, TextFieldControlled, useButtons, Typography, FormLabel, useSpinners } = useComponents();
  const { PublicContentLayout } = useLayouts();
  const { DefaultButton, KeycloakButton } = useButtons();
  const { SpinnerLoading } = useSpinners();

  // Controllers
  const { useScreenHooks } = useControllers();
  const { useLogin } = useScreenHooks();
  const { control, handleSubmit, onSubmit, handleForgot, handleKeycloakLogin, isCheckingKeycloak, autoRedirectEnabled, showPassword, handleTogglePasswordVisibility } = useLogin();

  // Show loading spinner while checking Keycloak session or auto-redirecting
  if (isCheckingKeycloak) {
    return <SpinnerLoading isOpen={true} text="Verificando sesión..." />;
  }

  // Show loading spinner during auto-redirect to Keycloak
  if (autoRedirectEnabled) {
    return <SpinnerLoading isOpen={true} text="Redirigiendo a Keycloak..." />;
  }

  return (
    <PublicContentLayout login>
      <Wrapper showLogo={true} description={""} maxWidth={"582px"} className="container gap-3" title={'Bienvenido a Membeer'} subTitle={<>Inicia sesión con los datos de tu cuenta <strong>ABInBev</strong> para gestionar tu producto.</>}>
        {/* Keycloak Login Button */}
        <div className="text-center">
          <KeycloakButton onClick={handleKeycloakLogin}>
            Ingresa por Ab-InBev
          </KeycloakButton>
        </div>

        <div className="flex items-center my-6">
          <div className="flex-1 border-t border-gray-200"></div>
          <Typography variant="body2" sx={{ px: 2 }}>
            O
          </Typography>
          <div className="flex-1 border-t border-gray-200"></div>
        </div>

        {/* Email/Password Login Form */}
        <form onSubmit={handleSubmit(onSubmit)} className="mt-2">
          <TextFieldControlled
            id={"email"}
            name={"email"}
            label={"Email"}
            type={"email"}
            placeholder={"mail@mail.com"}
            control={control}
          />
          <FormLabel
            label={
              <div className="text-center cursor-pointer mt-2 flex items-center justify-between">
                <Typography variant="caption" sx={{ fontWeight: 400 }}>
                  Contraseña
                </Typography>
                <Typography
                  variant="caption"
                  className="hover:text-primary underline"
                  sx={{ fontSize: "12px", fontWeight: 300, lineHeight: "17px" }}
                  onClick={() => handleForgot()}
                >
                  ¿Olvidaste tu contraseña?
                </Typography>
              </div>
            }
          />
          <TextFieldControlled
            id="password"
            name={"password"}
            type={showPassword ? "text" : "password"}
            placeholder={"********"}
            control={control}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleTogglePasswordVisibility}
                    tabIndex={-1}
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <div className="text-center mt-4">
            <DefaultButton
              type="submit"
              fullWidth={true}
              rounded={true}
              sx={{ backgroundColor: '#ffc107', '&:hover': { backgroundColor: '#FFCB2E' } }}
            >
              Iniciar sesión como externo
            </DefaultButton>
          </div>
        </form>
      </Wrapper>
    </PublicContentLayout>
  );
};

export default Login;
